import { type PriceAndPackageListDTO, type PriceInfo, transformPrice } from "~/domains/pricing/api/PriceInfo";
import { occUrl } from "~/app/api/occ/occFetch";
import { apiGET } from "~/app/api/apiCallsService";

const apiUrl = occUrl("/pna/getLcPrice");

export async function getLinearPriceInfo(
  productCode: string,
  configurationId: string,
  priceReference: string,
  activeCartId?: string,
): Promise<PriceInfo[]> {
  const params = new URLSearchParams();
  if (priceReference) {
    params.set("priceReference", priceReference);
  }
  if (activeCartId) {
    params.set("activeCartId", activeCartId);
  }
  const query = params.toString();
  const url = `${apiUrl}/${productCode}/${configurationId}${query ? `?${query}` : ""}`;

  const response = await apiGET(url);
  if (!response.ok) {
    throw new Error("Error fetching data");
  }
  const dto: PriceAndPackageListDTO = await response.json();
  const res = (dto.items ?? []).map(transformPrice);
  res.forEach((x) => (x.priceReference = priceReference));
  return res;
}
